export enum WizardPackagePWAViews {
  DEFAULT = "default",
  HOTWIRE = "hotwire",
}
